// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-title[data-v-91b7e002],\n.nav-icon[data-v-91b7e002] {\n  color: #424f62;\n}\n.nav-title[data-v-91b7e002] {\n  line-height: 17px;\n}\n.nav-item[data-v-91b7e002] {\n  width: 100%;\n}\n.active .nav-item > div[data-v-91b7e002] {\n  background-color: #E8EEF1;\n  border-radius: 8px;\n}\n.active .nav-title[data-v-91b7e002],\n.active .nav-icon[data-v-91b7e002] {\n  color: #0E6488;\n}", ""]);
// Exports
module.exports = exports;
